module.exports = __webpack_public_path__ + "img/10.39dda38a.png";